(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 87314:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(53386);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 53386:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var utils_wagmi__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47945);
/* harmony import */ var _views_Swap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66706);
/* harmony import */ var _views_Swap_SwapFeaturesContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59754);
// import { formatEther } from '@ethersproject/units'
// import { FACTORY_ADDRESS } from '@pancakeswap/sdk'
// import { getUnixTime, sub } from 'date-fns'
// import { gql } from 'graphql-request'
// import { GetStaticProps } from 'next'
// import Router from 'next/router'
// import { useEffect } from 'react'
// import { SWRConfig } from 'swr'
// import { getCakeVaultAddress } from 'utils/addressHelpers'
// import { getCakeContract } from 'utils/contractHelpers'
// import { getBlocksFromTimestamps } from 'utils/getBlocksFromTimestamps'
// import { bitQueryServerClient, infoServerClient } from 'utils/graphql'
// import Home from '../views/Home'




var IndexPage = function(param) {
    var totalTx30Days = param.totalTx30Days, addressCount30Days = param.addressCount30Days, tvl = param.tvl;
    // return (
    //   <SWRConfig
    //     value={{
    //       fallback: {
    //         totalTx30Days,
    //         addressCount30Days,
    //         tvl,
    //       },
    //     }}
    //   >
    //     <Home />
    //   </SWRConfig>
    // )
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_views_Swap_SwapFeaturesContext__WEBPACK_IMPORTED_MODULE_3__/* .SwapFeaturesProvider */ .OR, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_views_Swap__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {})
    });
};
// // Values fetched from TheGraph and BitQuery jan 24, 2022
// const txCount = 54780336
// const addressCount = 4425459
// const tvl = 6082955532.115718
// export const getStaticProps: GetStaticProps = async () => {
//   const totalTxQuery = gql`
//     query TotalTransactions($id: ID!, $block: Block_height) {
//       pancakeFactory(id: $id, block: $block) {
//         totalTransactions
//       }
//     }
//   `
//   const days30Ago = sub(new Date(), { days: 30 })
//   const results = {
//     totalTx30Days: txCount,
//     addressCount30Days: addressCount,
//     tvl,
//   }
//   if (process.env.SF_HEADER) {
//     try {
//       const [days30AgoBlock] = await getBlocksFromTimestamps([getUnixTime(days30Ago)])
//       if (!days30AgoBlock) {
//         throw new Error('No block found for 30 days ago')
//       }
//       const totalTx = await infoServerClient.request(totalTxQuery, {
//         id: FACTORY_ADDRESS,
//       })
//       const totalTx30DaysAgo = await infoServerClient.request(totalTxQuery, {
//         block: {
//           number: days30AgoBlock.number,
//         },
//         id: FACTORY_ADDRESS,
//       })
//       if (
//         totalTx?.pancakeFactory?.totalTransactions &&
//         totalTx30DaysAgo?.pancakeFactory?.totalTransactions &&
//         parseInt(totalTx.pancakeFactory.totalTransactions) > parseInt(totalTx30DaysAgo.pancakeFactory.totalTransactions)
//       ) {
//         results.totalTx30Days =
//           parseInt(totalTx.pancakeFactory.totalTransactions) -
//           parseInt(totalTx30DaysAgo.pancakeFactory.totalTransactions)
//       }
//     } catch (error) {
//       if (process.env.NODE_ENV === 'production') {
//         console.error('Error when fetching total tx count', error)
//       }
//     }
//   }
//   const usersQuery = gql`
//     query userCount($since: ISO8601DateTime, $till: ISO8601DateTime) {
//       ethereum(network: bsc) {
//         dexTrades(exchangeName: { in: ["Pancake", "Pancake v2"] }, date: { since: $since, till: $till }) {
//           count(uniq: senders)
//         }
//       }
//     }
//   `
//   if (process.env.BIT_QUERY_HEADER) {
//     try {
//       const result = await bitQueryServerClient.request(usersQuery, {
//         since: days30Ago.toISOString(),
//         till: new Date().toISOString(),
//       })
//       if (result?.ethereum?.dexTrades?.[0]?.count) {
//         results.addressCount30Days = result.ethereum.dexTrades[0].count
//       }
//     } catch (error) {
//       if (process.env.NODE_ENV === 'production') {
//         console.error('Error when fetching address count', error)
//       }
//     }
//   }
//   try {
//     const result = await infoServerClient.request(gql`
//       query tvl {
//         pancakeFactories(first: 1) {
//           totalLiquidityUSD
//         }
//       }
//     `)
//     const cake = await (await fetch('https://farms.pancake-swap.workers.dev/price/cake')).json()
//     const { totalLiquidityUSD } = result.pancakeFactories[0]
//     const cakeVaultV2 = getCakeVaultAddress()
//     const cakeContract = getCakeContract()
//     const totalCakeInVault = await cakeContract.balanceOf(cakeVaultV2)
//     results.tvl = parseFloat(formatEther(totalCakeInVault)) * cake.price + parseFloat(totalLiquidityUSD)
//   } catch (error) {
//     if (process.env.NODE_ENV === 'production') {
//       console.error('Error when fetching tvl stats', error)
//     }
//   }
//   return {
//     props: results,
//     revalidate: 60 * 60 * 24 * 30, // 30 days
//   }
// }
IndexPage.chains = utils_wagmi__WEBPACK_IMPORTED_MODULE_1__/* .CHAIN_IDS */ .vo;
/* harmony default export */ __webpack_exports__["default"] = (IndexPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1246,5931,4273,7506,9521,3659,3354,8324,8934,4787,7553,5140,9051,247,4286,1221,193,6706,9774,2888,179], function() { return __webpack_exec__(87314); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);